import moment from 'moment';
import timeDateFormat from 'config/timeDateFormat';
import dateFormat from 'config/dateFormat';

const getOrderLineDateOfDelivery = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      if (indexOrderLine['Date of Delivery']) {
        return moment(indexOrderLine['Date of Delivery'], timeDateFormat).format(dateFormat);
      }
      return indexOrderLine.dateOfDelivery;
    }

    return null;
  }
  return orderLine
    ? orderLine.map((item) => {
      if (item['Date of Delivery']) {
        moment(item['Date of Delivery'], timeDateFormat).format(dateFormat);
      }
      return item.dateOfDelivery;
    }).join(', ')
    : null;
};

export default getOrderLineDateOfDelivery;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDateOfDelivery.js